<template>
  <div v-if="price" class="flex items-center gap-3">
    <span
      v-if="recommendedPrice && recommendedPrice > price"
      class="text-gray-lighter line-through"
      v-html="recommendedPrice"
    />
    <span class="font-semibold" v-html="price" />
  </div>
</template>

<script setup lang="ts">
import { computed, type ComputedRef, type PropType } from 'vue';
import type { SelectorOption } from '@/types/Configurator/SelectorOption';
import { useSizeStore } from '@/stores/Configurator/SizeStore.ts';

const props = defineProps({
  option: {
    type: Object as PropType<SelectorOption>,
    required: true,
  },

  isAmountFilter: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const sizeStore = useSizeStore();

const price: ComputedRef<string | undefined> = computed(() =>
  props.isAmountFilter
    ? sizeStore.getAmountFilterPrice(props.option as SelectorOption)
    : props.option?.localizedPrice
);

const recommendedPrice: ComputedRef<string | undefined> = computed(() =>
  props.isAmountFilter
    ? sizeStore.getAmountFilterRecommendedPrice(props.option as SelectorOption)
    : props.option?.localizedRecommendedPrice
);
</script>
